import React from 'react';
import axios from 'axios';
import { View, RefreshControl, Appearance, FlatList } from 'react-native';
import { Note } from 'iconsax-react-native';
import { Text } from 'react-native-paper';
import { usePathname } from 'expo-router';
import { MotiView } from 'moti';
import { Skeleton } from 'moti/skeleton';
import { MainContext } from '../../contexts/MainContext';
import Spacer from '../../components/Spacer/Spacer';
import AdsCard from '../../components/cards/AdsCard/AdsCard';
import Filters from '../../components/Filters/Filters';
 
export default function NeedUpdate(){
  const myContext = React.useContext(MainContext);
  const pathname = usePathname();
  const [pageLoading, setPageLoading] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [isReflesh, setIsReflesh] = React.useState(false);
  const colorScheme = Appearance.getColorScheme();
  const [data, setData] = React.useState([]);
  //const memoizedData = React.useMemo(() => data, [data]);
  const [isEmpty, setIsEmpty] = React.useState(false);
  const [loadMoreIsEmpty, setLoadmoreIsEmpty] = React.useState(false);
  const [searchData, setSearchData] = React.useState({});
  const [sortedData, setSortedData] = React.useState('all');
  const [adsDetail, setAdsDetail] = React.useState({});

  React.useEffect(() => {
    getData();
  }, [pathname])

  React.useEffect(() => {
    //if(Object.keys(searchData).length > 0) {
      getData();
    //}
  }, [searchData])

  React.useEffect(() => {
    getData();
  }, [sortedData])

  const getData = (page = 1) => {
    setPageLoading(true);
    setIsReflesh(true)
    setPage(1);
    axios.all([
      axios.post(`/panel/ads/needUpdate?page=${page}`, {search: searchData, sort: sortedData}),
      axios.post(`/panel/ads/needUpdate-detail`),
    ])
    .then(axios.spread((response, detail) => {
      if(detail.data.success) {
        setAdsDetail(detail.data.data);
      }
      if(Object.keys(response.data.data).length === 0) {
        setIsEmpty(true);
      }
      setData(response.data.data);
    }))
    .catch(myContext.handleAxiosError)
    .finally(() => {setPageLoading(false); setIsReflesh(false)});
  }

  const loadmore = (page) => {
    axios.all([
      axios.post(`/panel/ads/needUpdate?page=${page}`, {search: searchData, sort: sortedData}),
    ])
    .then(axios.spread((response) => {
      if(Object.keys(response.data.data).length === 0) {
        setLoadmoreIsEmpty(true);
      }
      setData(prev => [...prev, ...response.data.data]);
    }))
    .catch(myContext.handleAxiosError)
    .finally(() => {});
  }

  const renderListItem = React.useCallback((item) => <AdsCard data={item} isMy={false} isTransfered={false} needUpdate reload={data => data && getData()} />, []);

  const skeletonContent = (isSmall = false) => {
    return (
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={{ flex: 1, justifyContent: 'space-between', paddingVertical: !isSmall ? 16 : 0, paddingHorizontal: !isSmall ? 18 : 0 }}
        animate={{ backgroundColor: colorScheme === 'dark' ? '#000000' : '#ffffff' }}
      >
        <View>
          {
            !isSmall &&
              <>
                <Skeleton colorMode={colorScheme} width={'100%'} height={100} />
                <Spacer height={8} />
                <Skeleton colorMode={colorScheme} width={'100%'} height={50} /> 
                <Spacer height={8} />
              </>
          }
          <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
          <Spacer height={8} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
          {
            !isSmall &&
              <>
                <Spacer height={8} />
                <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
                <Spacer height={8} />
                <Skeleton colorMode={colorScheme} width={'100%'} height={250} />
              </>
          }
        </View>
      </MotiView>
    );
  }

  if(pageLoading) {
    return skeletonContent();
  } else {
    return (
      <View style={{ flex: 1, backgroundColor: '#fcfcfd' }}>
        <FlatList               
          data={Object.values(data)}
          contentContainerStyle={{ paddingHorizontal: 18, paddingVertical: 16 }}
          keyExtractor={(item, index) => index.toString()}
          renderItem={({ item }) => renderListItem(item)}
          initialNumToRender={10}
          ListHeaderComponent={() => <Filters filtersValue={searchData} submitFilterData={data => setSearchData(data)} sortData={data => setSortedData(data) } sortValue={sortedData} adsDetail={adsDetail} />}
          ListFooterComponent={() => isEmpty ? null : loadMoreIsEmpty ? null : skeletonContent(true)}
          onEndReachedThreshold={.8} 
          ListEmptyComponent={() => (
            <View style={{ marginTop: 32, flex: 1, justifyContent: 'center', alignItems: 'center' }}>
              <Note size="48" color="#292D32" variant="Outline"/>
              <Text style={{ marginTop: 6, fontSize: 14, color: '#5B5E63' }}>نتیجه‌ای پیدا نشد</Text>
            </View>
          )}
          refreshControl = {
            <RefreshControl
              refreshing={isReflesh}
              onRefresh={() => {
                setSearchData({});
                setSortedData('all');
                getData();
              }}
            />
          }
          onEndReached={({distanceFromEnd}) => {
            if(distanceFromEnd >= 0) {
                setPage(page + 1)
                loadmore(page + 1);
            }
          }}
        />
      </View>
    );
  }
};